<template>
  <div
    class="auth-page min-h-screen relative w-full bg-center-top bg-no-repeat bg-cover text-center pb-4 sm:pb-20"
  >
    <div class="py-5">
      <img alt="startup ACT" class="startup-auth-logo" src="../../assets/img/header-auth-space.svg" />
    </div>

    <div
      class="wrap-login w-68 sm:w-75 max-w-full bg-white shadow-lg rounded-sm p-5 mx-auto" :class="{'opacity-50 cursor-not-allowed':load}"
    >
      <h2
        class="text-2xl font-bold leading-normal text-red uppercase border-b-2 border-red-lighter p-5 mb-4"
      >
        {{ $t("auth.verify_account") }}
      </h2>
      <div
        v-if="!valid_token && !load"
        class="border border-red-light text-red-dark px-4 py-3 mb-4 rounded"
      >
        <div class="relative error-messages block sm:inline text-left p-0 ">
          {{ $t("auth.token_invalid") }}
        </div>
      </div>
      <div
        v-if="valid_token && !load"
        class="border border-green-light text-green text-sm px-4 py-3 mb-4 rounded"
      >
        <div class="relative  block sm:inline text-left p-0">
          {{ $t(notice) }}
        </div>
      </div>
      <div
        v-if="errors != null"
        class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 mb-4 rounded relative"
        role="alert"
      >
        <strong class="font-bold mb-5">{{ errors.message }}</strong>

        <ul
          v-if="errors"
          class="error-messages block sm:inline text-left p-0 list-reset"
        >
          <li v-for="(v, k) in errors" :key="k" class="mx-2">
            {{ v.message }}
          </li>
        </ul>
      </div>

      <div
        class="flex items-center justify-center border-t border-blue-lighter pt-5 pb-2"
      >
        <p>{{ $t("auth.not_have_account") }}</p>
        <sp-link
          theme="warning"
          class="inline-block ml-2 font-bold hover:text-red-lighter"
          :to="{ name: 'register' }"
          >{{ $t("auth.sing_up") }}</sp-link
        >
      </div>
    </div>

    
    <footer
      class="flex items-center justify-between text-grey-darker bg-grey-lighter absolute md:absolute pin-b pin-l invisible md:visible w-full py-1 px-3 transition-all"
    >
      <div class="flex items-center">
        <img
          class="mh-8 mx-2"
          alt="Ministère des Technologies de la Communication et de la Transformation Digitale"
          src="../../assets/img/drapeau.png"
        />
        <span class=" text-xxs opacity-60"
          >{{ $t('auth.ministry') }}</span
        >
      </div>
      <div class="sm:w-70 w-60 text-right text-xs">
        {{ $t('auth.technology_by') }} <a class="inline-block text-sm font-bold no-underline cursor-pointer transition-all text-grey-darker hover:text-grey-darker" href="https://www.satoripop.com/" target="_blank">satoripop</a>
      </div>
    </footer>
  </div>
</template>

<style></style>

<script>
import ApiService from "@/common/api.service";
import { mapState } from "vuex";
import {  CLEAR_ERROR } from "@/store/actions.type";
import { VERIFY_USER } from "@/store/mutations.type";
import Link from "@/components/spKit/Link.vue";
import Button from "@/components/spKit/Button.vue";
import Input from "@/components/spKit/Input.vue";

export default {
  name: "VERIFYUSER",
  components: {
    "sp-link": Link,
    "sp-button": Button,
    "sp-input": Input
  },
  data() {
    return {
      email: "",
      password: "",
      password_confirmation: "",
      error: "",
      notice: "",
      valid_token: false,
      disabled_class : "",
      load:true
    };
  },
  created() {
    this.checkToken();
  },
  methods: {
    acivateSuccessful() {
      this.notice = "auth.verify_user_success";
      this.email = "";
      this.password = "";
      this.password_confirmation = "";
    },
    checkToken() {
      ApiService.post("/candidates/verify", {
        verification_code: this.$route.params.token,
        code_invit: this.$route.params.codeInvit
      }).then(() => {
          this.valid_token = true;
          this.acivateSuccessful();
          this.load = false;
          this.$store.commit(VERIFY_USER,'auth.verify_user_success');
          this.$router.push({ name: "login" });

        })
      .catch(err => {
          this.valid_token = false;
          this.load = false;
        })
        
        
    }
  },
  watch:{
    errors(){
       this.$Progress.fail();
       this.disabled_class = "";
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
